module.exports = __webpack_public_path__ + "img/banner.8592be39.jpg";